import { z } from 'zod';

export const RepeatIntervalSchema = z.enum(['weekly', 'monthly', 'yearly']);
export type RepeatInterval = z.infer<typeof RepeatIntervalSchema>;

export const RecurringVersionSchema = z.object({
  effective_from: z.string(),
  description: z.string(),
  amount: z.number(),
  currency_code: z.string(),
  category_id: z.string(),
  paid_by: z.string(),
});

export const RecurringExpenseSchema = z.object({
  id: z.string(),
  group_id: z.string(),
  description: z.string(),
  amount: z.number(),
  currency_code: z.string(),
  category: z.object({
    id: z.string(),
    name: z.string(),
    emoji: z.string().nullable().optional(),
  }).nullable(),
  paid_by: z.object({
    id: z.string(),
    name: z.string().nullable(),
  }).nullable(),
  repeat_interval: RepeatIntervalSchema,
  interval_count: z.number(),
  start_date: z.string(),
  end_date: z.string().nullable(),
  is_active: z.boolean(),
  next_due_date: z.string().nullable(),
  materialized_count: z.number(),
  versions: z.array(RecurringVersionSchema),
});
export type RecurringExpense = z.infer<typeof RecurringExpenseSchema>;

export const ListRecurringExpensesResponseSchema = z.object({
  recurring_expenses: z.array(RecurringExpenseSchema),
});

export const CreateRecurringExpenseResponseSchema = z.object({
  id: z.string(),
  materialized_count: z.number(),
  adopted_count: z.number().optional(),
});

export const BackfillCandidateSchema = z.object({
  id: z.string(),
  description: z.string(),
  amount: z.number(),
  date: z.string(),
  category_id: z.string(),
  category_name: z.string().nullable(),
});
export type BackfillCandidate = z.infer<typeof BackfillCandidateSchema>;

export const BackfillPreviewRowSchema = z.object({
  occurrence_date: z.string(),
  candidates: z.array(BackfillCandidateSchema),
});
export type BackfillPreviewRow = z.infer<typeof BackfillPreviewRowSchema>;

export const PreviewBackfillResponseSchema = z.object({
  occurrences: z.array(BackfillPreviewRowSchema),
});

export const UpdateRecurringExpenseResponseSchema = z.object({
  id: z.string(),
  effective_date: z.string(),
  deleted_occurrences: z.number(),
  created_occurrences: z.number(),
});

export const CancelRecurringExpenseResponseSchema = z.object({
  id: z.string(),
  deleted_occurrences: z.number(),
});

export const RecurringTransactionSchema = z.object({
  id: z.string(),
  description: z.string(),
  amount: z.number(),
  currency_code: z.string(),
  date: z.string(),
  occurrence_date: z.string().nullable(),
  adopted: z.boolean(),
  paid_by: z.object({
    id: z.string(),
    name: z.string().nullable(),
  }),
  category: z.object({
    name: z.string(),
    emoji: z.string().nullable(),
  }).nullable(),
});
export type RecurringTransaction = z.infer<typeof RecurringTransactionSchema>;

export const RecurringTransactionsResponseSchema = z.object({
  transactions: z.array(RecurringTransactionSchema),
});
